/**
 * KAAMWALA design tokens - taken from the logo: royal blue #1B4DE4,
 * orange #F97316, white.
 *
 * The same values are mirrored as CSS custom properties in index.css. Use the
 * CSS variables in stylesheets and this object wherever JavaScript needs a
 * colour (inline styles for dynamic tints, chart colours, etc).
 */
export const colors = {
  primary: '#1B4DE4',
  primaryDark: '#0B2FA8',
  primaryLight: '#EEF3FF',
  primarySoft: '#DCE6FF',

  accent: '#F97316',
  accentDark: '#EA580C',
  accentLight: '#FFF3E9',

  ink: '#0F172A',
  ink2: '#334155',
  muted: '#64748B',
  faint: '#94A3B8',

  line: '#E7EBF3',
  bg: '#F6F8FC',
  card: '#FFFFFF',
  white: '#FFFFFF',

  success: '#16A34A',
  successBg: '#E8F8EE',
  danger: '#DC2626',
  dangerBg: '#FDECEC',
  warning: '#D97706',
  warningBg: '#FEF4E6',
  info: '#0EA5E9',
  infoBg: '#E3F5FE',

  star: '#F59E0B',
  overlay: 'rgba(15,23,42,0.55)',
};

export const spacing = {
  xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 28, xxxl: 40,
};

export const radius = {
  sm: 8, md: 12, lg: 16, xl: 22, pill: 999,
};

/** Breakpoint the layout switches from bottom tabs to a desktop sidebar. */
export const DESKTOP_MIN = 900;

const theme = { colors, spacing, radius, DESKTOP_MIN };
export default theme;
